var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"h-100 w-100"},[(_vm.loading)?_c('div',{key:0,staticClass:"loading"},[_c('loading')],1):_c('div',{key:1,staticClass:"app-wrapper"},[_c('vue-page-transition',{staticClass:"app-wrapper",attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }